import React, { Component } from 'react';
import IconRender from '../std/IconRender';
import ContRoutingInfo from '../../containers/ContRoutingInfo';
import ContMessageI18N from '../../containers/ContMessageI18N';

class TestToolBar extends Component {

    getMessage(i18nKey) {
        return <ContMessageI18N i18n={i18nKey} />
    }
    handleChangeLangage = newValue => {
        this.props.onChangeLanguage(newValue, this.props.context.languageCode);
    }

    render() {
        const activeManufacturer = this.props.settings.vehDescType === 'MANUFACTURER' ? ' active' : ' inactive';
        const activeAnyBrand = this.props.settings.vehDescType === 'ANYBRAND' ? ' active' : ' inactive';
        const languages = ['xx', 'fr', 'en'];
        return (
            <div className="btn-group w-100">
                <button type="button" className={`btn btn-light p-0 ${activeManufacturer}`}
                    onClick={() => this.props.onChangeVehicleDescriptionType('MANUFACTURER')}>
                    {this.getMessage('testpage.header.vehDescType.MANUFACTURER')}
                </button>
                <button type="button" className={`btn btn-light p-0 ${activeAnyBrand}`}
                    onClick={() => this.props.onChangeVehicleDescriptionType('ANYBRAND')}>
                    {this.getMessage('testpage.header.vehDescType.ANYBRAND')}
                </button>
                <div className="col-auto">
                    <div className="dropdown col-auto">
                        <button className="btn btn-light dropdown-toggle py-0" type="button" id="dropdownMenuButtonLanguage" data-bs-toggle="dropdown" aria-expanded="false">
                            {(!this.props.settings.language || this.props.settings.language === 'xx')
                                && this.getMessage('testpage.header.language')}
                            {this.props.settings.language != null && this.props.settings.language !== 'xx'
                                && this.getMessage(`testpage.header.language.${this.props.settings.language}`)}
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonLanguage" >
                            {languages.map((language, index) => (
                                <li key={index}>
                                    <button className="dropdown-item" type="button" onClick={() => { this.handleChangeLangage(language) }}>
                                        {this.getMessage(`testpage.header.language.${language}`)}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="col-auto">
                    <button id="refreshSimulation" className="btn btn-light p-0 px-2" onClick={() => this.props.onForce()}>
                        <IconRender name="arrow-repeat" />
                    </button>
                </div>
                <ContRoutingInfo />
            </div>
        )
    }
}

export default (TestToolBar)
